import { ADD_TO_CART, DELETE_FROM_CART } from "./cartActionTypes"


const initialState={
    cart:[],
}


export const cartReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case ADD_TO_CART:
            return {...state,cart:payload}
        case DELETE_FROM_CART:
            return {...state,cart:payload}
        default:
            return state
    }
}